import React, { useEffect, useState } from "react";
import axios from "axios";
import { useOutletContext, useParams } from "react-router-dom";
import { FaUserPlus, FaTrash, FaCopy, FaCheckCircle, FaWhatsapp, FaEdit, FaTimes, FaFilePdf } from "react-icons/fa";
import "../../styles/circuitoDesignSystem.css";

export default function CircuitoAfiliadosPainel() {
  const { circuito, slugAtivo } = useOutletContext();
  const { slug: urlSlug } = useParams();
  const slug = slugAtivo || urlSlug;
  
  const [afiliados, setAfiliados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ nome: "", codigo: "", telefone: "" });
  
  const [editandoId, setEditandoId] = useState(null);

  const [copiadoId, setCopiadoId] = useState(null);
  const [copiadoPainelId, setCopiadoPainelId] = useState(null);
  
  const [enviandoWpp, setEnviandoWpp] = useState(null);
  const [baixandoPdfId, setBaixandoPdfId] = useState(null); // 💡 NOVO: Controle de Download do PDF

  useEffect(() => {
    if (circuito?._id) buscarAfiliados();
  }, [circuito]);

  const buscarAfiliados = async () => {
    const res = await axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/afiliados`);
    setAfiliados(res.data);
  };

  const handleSalvar = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (editandoId) {
        await axios.put(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/afiliados/${editandoId}`, form);
      } else {
        await axios.post(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/afiliados`, form);
      }
      setForm({ nome: "", codigo: "", telefone: "" });
      setEditandoId(null);
      buscarAfiliados();
    } catch (err) {
      alert(err.response?.data?.error || "Erro ao salvar afiliado");
    } finally {
      setLoading(false);
    }
  };

  const iniciarEdicao = (af) => {
    setEditandoId(af._id);
    setForm({ nome: af.nome, codigo: af.codigo, telefone: af.telefone || "" });
    window.scrollTo({ top: 0, behavior: "smooth" }); 
  };

  const cancelarEdicao = () => {
    setEditandoId(null);
    setForm({ nome: "", codigo: "", telefone: "" });
  };

  const deletarAfiliado = async (id) => {
    if (!window.confirm("Remover este afiliado? (As vendas passadas não serão apagadas)")) return;
    await axios.delete(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/afiliados/${id}`);
    if (editandoId === id) cancelarEdicao(); 
    buscarAfiliados();
  };

  const enviarRelatorioManual = async (id) => {
    setEnviandoWpp(id);
    try {
      await axios.post(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/afiliados/${id}/enviar-relatorio`);
      alert("Relatório PDF enviado com sucesso para o WhatsApp do afiliado!");
    } catch (err) {
      alert(err.response?.data?.error || "Erro ao enviar relatório.");
    } finally {
      setEnviandoWpp(null);
    }
  };

  // 💡 NOVO: Função para baixar o PDF direto para o computador
  const baixarRelatorioPdf = async (id, nome) => {
    setBaixandoPdfId(id);
    try {
      const res = await axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/afiliados/${id}/relatorio-pdf`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      const dataHojeStr = new Date().toLocaleDateString('pt-BR').replace(/\//g, '-');
      link.setAttribute('download', `Relatorio_Afiliado_${nome.replace(/\s+/g, '')}_${dataHojeStr}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      console.error(err);
      alert("Erro ao baixar o relatório em PDF.");
    } finally {
      setBaixandoPdfId(null);
    }
  };

  const isCustomDomain = window.location.hostname !== "ticketdovaqueiro.com" && window.location.hostname !== "www.ticketdovaqueiro.com" && window.location.hostname !== "localhost";
  const baseUrl = window.location.origin;

  const copiarLink = (codigo, id) => {
    const linkUrl = isCustomDomain ? `${baseUrl}/?ref=${codigo}` : `${baseUrl}/circuito/${slug}?ref=${codigo}`;
    navigator.clipboard.writeText(linkUrl);
    setCopiadoId(id);
    setTimeout(() => setCopiadoId(null), 2000);
  };

  const copiarLinkPainel = (codigo, id) => {
    const linkUrl = isCustomDomain ? `${baseUrl}/afiliado/${codigo}` : `${baseUrl}/circuito/${slug}/afiliado/${codigo}`;
    navigator.clipboard.writeText(linkUrl);
    setCopiadoPainelId(id);
    setTimeout(() => setCopiadoPainelId(null), 2000);
  };

  return (
    <div style={{ paddingBottom: "40px" }}>
      <div className="pc-page-header">
        <h1 className="pc-page-header__title">Programa de Afiliados</h1>
        <p className="pc-page-header__subtitle">Crie links personalizados para parceiros divulgarem seu circuito.</p>
      </div>

      <form onSubmit={handleSalvar} className="pc-card" style={{ marginBottom: 32, display: "grid", gap: 16 }}>
        <h3 style={{ fontSize: 16, margin: 0, color: "#fff", display: "flex", alignItems: "center", gap: 8 }}>
          {editandoId ? <><FaEdit color="var(--c-accent)"/> Editando Parceiro</> : "Cadastrar Novo Parceiro"}
        </h3>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 16 }}>
          <div>
            <label style={{ display: "block", marginBottom: 6, fontSize: 13, color: "rgba(255,255,255,0.6)" }}>Nome do Afiliado *</label>
            <input type="text" required value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} className="c-input" placeholder="Ex: João Vaqueiro" style={{ width: "100%", height: 44, paddingLeft: 16 }} />
          </div>
          <div>
            <label style={{ display: "block", marginBottom: 6, fontSize: 13, color: "rgba(255,255,255,0.6)" }}>Código do Link (URL) *</label>
            <input type="text" required value={form.codigo} onChange={e => setForm({...form, codigo: e.target.value.toLowerCase().replace(/\s+/g, "-")})} className="c-input" placeholder="Ex: joao-vaqueiro" style={{ width: "100%", height: 44, paddingLeft: 16 }} />
          </div>
          <div>
            <label style={{ display: "block", marginBottom: 6, fontSize: 13, color: "rgba(255,255,255,0.6)" }}>WhatsApp (Opcional)</label>
            <input type="text" value={form.telefone} onChange={e => setForm({...form, telefone: e.target.value})} className="c-input" placeholder="(00) 00000-0000" style={{ width: "100%", height: 44, paddingLeft: 16 }} />
          </div>
        </div>
        
        <div style={{ display: "flex", gap: 12 }}>
          <button type="submit" disabled={loading} className="c-btn c-btn--primary" style={{ height: 44, padding: "0 24px", display: "flex", gap: 8, alignItems: "center", justifyContent: "center" }}>
            {editandoId ? <FaEdit /> : <FaUserPlus />}
            {loading ? "Salvando..." : editandoId ? "Salvar Alterações" : "Gerar Link de Afiliado"}
          </button>
          
          {editandoId && (
            <button type="button" onClick={cancelarEdicao} className="c-btn" style={{ background: "transparent", color: "#888", border: "1px solid #444", height: 44, padding: "0 16px", display: "flex", gap: 8, alignItems: "center" }}>
              <FaTimes /> Cancelar
            </button>
          )}
        </div>
      </form>

      <div className="pc-card">
        <h3 style={{ fontSize: 16, marginBottom: 16, color: "#fff" }}>Parceiros e Rendimentos</h3>
        <div style={{ overflowX: "auto" }}>
          <table className="pc-table" style={{ minWidth: 900 }}>
            <thead>
              <tr>
                <th>Afiliado</th>
                <th>Links de Divulgação</th>
                <th style={{ textAlign: "center" }}>Associações Pagas</th>
                <th style={{ textAlign: "right" }}>Total Arrecadado (R$)</th>
                <th style={{ textAlign: "center" }}>Ação</th>
              </tr>
            </thead>
            <tbody>
              {afiliados.length === 0 ? (
                <tr><td colSpan="5" style={{ textAlign: "center", padding: 30, color: "rgba(255,255,255,0.4)" }}>Nenhum afiliado cadastrado.</td></tr>
              ) : (
                afiliados.map(af => (
                  <tr key={af._id} style={{ background: editandoId === af._id ? "rgba(255,255,255,0.05)" : "transparent" }}>
                    <td>
                      <strong style={{ color: "#fff", display: "block" }}>{af.nome}</strong>
                      <small style={{ color: "rgba(255,255,255,0.5)" }}>{af.telefone || "S/ Número"}</small>
                    </td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, background: "rgba(59, 130, 246, 0.1)", border: "1px solid rgba(59, 130, 246, 0.2)", padding: "6px 12px", borderRadius: 8, width: "fit-content" }}>
                          <span style={{ fontSize: 11, color: "#3b82f6", fontWeight: "bold" }}>🔗 LINK VENDAS</span>
                          <button onClick={() => copiarLink(af.codigo, af._id)} style={{ background: "none", border: "none", color: copiadoId === af._id ? "#10b981" : "#3b82f6", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }} title="Copiar Link de Divulgação">
                            {copiadoId === af._id ? <FaCheckCircle /> : <FaCopy />}
                          </button>
                        </div>
                        
                        <div style={{ display: "flex", alignItems: "center", gap: 8, background: "rgba(16, 185, 129, 0.1)", border: "1px solid rgba(16, 185, 129, 0.2)", padding: "6px 12px", borderRadius: 8, width: "fit-content" }}>
                          <span style={{ fontSize: 11, color: "#10b981", fontWeight: "bold" }}>📊 LINK PAINEL DELE</span>
                          <button onClick={() => copiarLinkPainel(af.codigo, af._id)} style={{ background: "none", border: "none", color: copiadoPainelId === af._id ? "#10b981" : "#10b981", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }} title="Copiar Link do Painel do Afiliado">
                            {copiadoPainelId === af._id ? <FaCheckCircle /> : <FaCopy />}
                          </button>
                        </div>
                      </div>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <span style={{ background: "rgba(59, 130, 246, 0.15)", color: "#3b82f6", padding: "4px 10px", borderRadius: 12, fontWeight: "bold", fontSize: 13 }}>
                        {af.qtdVendas} vendas
                      </span>
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold", color: "#10b981", fontSize: 15 }}>
                      R$ {Number(af.valorArrecadado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </td>
                    <td style={{ textAlign: "center", display: "flex", gap: "8px", justifyContent: "center" }}>
                      
                      <button 
                        onClick={() => iniciarEdicao(af)} 
                        title="Editar Afiliado"
                        style={{ background: "rgba(59, 130, 246, 0.15)", color: "#3b82f6", border: "none", padding: 8, borderRadius: 8, cursor: "pointer", transition: "0.2s" }}>
                        <FaEdit size={16} />
                      </button>

                      {/* 💡 NOVO: Botão de Baixar PDF */}
                      <button 
                        title="Baixar Relatório PDF" 
                        onClick={() => baixarRelatorioPdf(af._id, af.nome)}
                        disabled={baixandoPdfId === af._id}
                        style={{
                          background: "rgba(239, 68, 68, 0.15)", color: "#ef4444", border: "none", 
                          padding: "8px", borderRadius: "8px", cursor: baixandoPdfId === af._id ? "wait" : "pointer", 
                          transition: "all 0.2s", display: "flex", alignItems: "center", justifyContent: "center",
                          opacity: baixandoPdfId === af._id ? 0.5 : 1
                        }}
                      >
                        <FaFilePdf size={16} />
                      </button>

                      <button 
                        onClick={() => enviarRelatorioManual(af._id)} 
                        disabled={enviandoWpp === af._id}
                        title="Enviar PDF Relatório no WhatsApp"
                        style={{ background: "rgba(37, 211, 102, 0.15)", color: "#25D366", border: "none", padding: 8, borderRadius: 8, cursor: "pointer", transition: "0.2s", opacity: enviandoWpp === af._id ? 0.5 : 1 }}>
                        <FaWhatsapp size={16} />
                      </button>

                      <button 
                        onClick={() => deletarAfiliado(af._id)} 
                        style={{ background: "rgba(100, 116, 139, 0.15)", color: "#64748b", border: "none", padding: 8, borderRadius: 8, cursor: "pointer", transition: "0.2s" }}>
                        <FaTrash size={16} />
                      </button>

                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}